import { TagApiModel } from '../../../api/tags/tag-api.model';
import { ChipModel } from '../../Forms/models/chip.model';
import { BaseModel } from '../../../Common/Basic/models/base.model';

export class TagModel extends BaseModel<TagModel, TagApiModel> {

    id: number;
    name: string;

    createdByUserId: number;
    createdDate: number;

    lastModifiedByUserId: number;
    lastModifiedDate: number;

    constructor(tagApi?: TagApiModel) {
        super();
        if (tagApi) {
            this.id = tagApi.id;
            this.name = tagApi.name;

            this.createdByUserId = tagApi.createdByUserId;
            this.createdDate = tagApi.createdDate;

            this.lastModifiedByUserId = tagApi.lastModifiedByUserId;
            this.lastModifiedDate = tagApi.lastModifiedDate;
        }
    }

    constructFromApiModel(apiModel: TagApiModel): TagModel {
        return new TagModel(apiModel);
    }


    toApiModel(): TagApiModel {
        return {
            id:                   this.id,
            name:                 this.name,
            createdByUserId:      this.createdByUserId,
            createdDate:          this.createdDate,
            lastModifiedByUserId: this.lastModifiedByUserId,
            lastModifiedDate:     this.lastModifiedDate
        };
    }

    /**
     * Converts tag to a chip model
     */
    toChipModel(): ChipModel {
        return {
            label: this.name,
            id: this.id
        };
    }

    /**
     * Returns an api model cloned with tag name
     */
    clone(): TagModel {
        return new TagModel(this.toApiModel());
    }


    equals(other?: TagModel): boolean {
        if (!other) {
            return false;
        }

        if (this.id !== other.id) {
            return false;
        }

        if (this.name !== other.name) {
            return false;
        }

        if (this.createdByUserId !== other.createdByUserId) {
            return false;
        }

        if (this.createdDate !== other.createdDate) {
            return false;
        }

        if (this.lastModifiedByUserId !== other.lastModifiedByUserId) {
            return false;
        }

        if (this.lastModifiedDate !== other.lastModifiedDate) {
            return false;
        }

        return true;
    }

    /** @deprecated Not implemented */
    constructDefault() {}
}
